import React from 'react'
import { useOnbordApartment } from '../../assets/api/useMarketingExecutive'
import useAuthStore from '../../store/useAuthStore'
import CommonTermAndCondtion from '../commonfile/CommonTermAndCondtion'

const OnboardTCManager = () => {
    const { user } = useAuthStore()
    const { data: apartmentList, isLoading: isApartmentListLoading } = useOnbordApartment({ city_name: user?.city })
    return (
        <CommonTermAndCondtion apartmentRow={apartmentList?.data} isloadingApartment={isApartmentListLoading} />
    )
}

export default OnboardTCManager